<template>
  <div class="main-ting">
    <div class="mt-3">
      <income-adder
        v-bind:club_id="this.$cookie.get('club_id')"
        v-on:refresh-stuff="refreshBalance()"
      />
    </div>
    <div class="col-4">
      <b-form-group
        label="Пошук"
        label-for="filter-input"
        label-align-sm="right"
        label-size="sm"
        class="mb-0"
      >
        <b-input-group>
          <b-form-input
            id="filter-input"
            v-model="filter"
            type="search"
            placeholder="Введіть текст пошуку"
          ></b-form-input>

          <b-input-group-append>
            <b-button class="ms-3" :disabled="!filter" @click="filter = ''"
              >Очистити</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <div v-if="incomes !== null" class="mt-3 overflow-auto">
      <b-pagination
        ref="pagin"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        aria-controls="income-table"
      ></b-pagination>

      <b-table
        id="income-table"
        :fields="contolFields"
        :items="makeTable()"
        :per-page="perPage"
        :current-page="currentPage"
        bordered
        striped
        responsive
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        show-empty
        :filter="filter"
        @row-clicked="(item) => $set(item, '_showDetails', !item._showDetails)"
      >
        <!--        <template #cell(Способ)="row">-->
        <!--          <p v-if="Number(row.item.income.payment_type) === 1">Наличка<b-icon class="ms-1" icon="cash-stack"></b-icon></p>-->
        <!--          <p v-if="Number(row.item.income.payment_type) === 2">Карта<b-icon class="ms-1" icon="credit-card"></b-icon></p>-->
        <!--        </template>-->
        <template #cell(delete)="row">
          <b-icon
            icon="x-circle"
            variant="danger"
            @click="deleteIncome(row.item.income)"
          >
          </b-icon>
        </template>
      </b-table>
    </div>
    <Alert
      :class="this.class"
      v-bind:text="this.AlertText"
      v-bind:activErr="this.activErr"
    ></Alert>
  </div>
</template>

<script>
import Alert from "@/components/Toasts/Alert";
import axios from "axios";

var moment = require("moment");
import IncomeAdder from "@/components/modals/IncomeAdder";
import { mapActions, mapState } from "vuex";
export default {
  name: "Incomes",
  props: {
    incomes: [],
  },
  components: {
    IncomeAdder,
    Alert,
  },
  data: function () {
    return {
      sortBy: "Время",
      sortDesc: true,
      perPage: 15,
      currentPage: 1,
      filter: null,
      totalRows: 0,
      fields: [
        { key: "time", label: "Час", sortable: false, sortDirection: "desc" },
        {
          key: "amount",
          label: "Сума",
          sortable: false,
          sortDirection: "desc",
        },
        "Причина",
        "Спосіб",
        "Опис",
        "Адмін",
        "Видалення",
      ],
      activErr: false,
      class: "",
      AlertText: "",
    };
  },
  computed: {
    ...mapState(["user"]),
    contolFields() {
      if (this.user[0].role == "superadmin") {
        return [
          { key: "time", label: "Час", sortable: false, sortDirection: "desc" },
          {
            key: "amount",
            label: "Сума",
            sortable: false,
            sortDirection: "desc",
          },
          "Спосіб",
          "Причина",
          "Опис",
          "Адмін",
          { key: "delete", label: "Видалення" },
        ];
      } else {
        return [
          { key: "time", label: "Час", sortable: false, sortDirection: "desc" },
          {
            key: "amount",
            label: "Сума",
            sortable: false,
            sortDirection: "desc",
          },
          "Спосіб",
          "Причина",
          "Опис",
          "Адмін",
        ];
      }
    },
  },
  methods: {
    ...mapActions(["logOutUser"]),
    validateIncome(source) {
      if (source === 1) {
        return "Продажа карти";
      } else if (source === 2) {
        return "Разовий гість";
      } else if (source === 3) {
        return "Спортпіт";
      } else if (source === 4) {
        return "Кава";
      } else if (source === 5) {
        return "Оренда приміщення";
      } else {
        return source;
      }
    },
    showModalCreate(text, color) {
      this.activErr = true;
      this.class = color;
      this.AlertText = text;
      setTimeout(() => {
        this.activErr = false;
      }, 2500);
    },
    refreshBalance() {
      this.$emit("refresh-balance");
    },
    makeTable() {
      let options = [];
      let incomeList = this.incomes;
      incomeList.forEach((income) => {
        options.push({
          time: moment(income.daytime).locale("uk").format("DD-MM-YYYY HH:mm"),
          amount: income.amount + " грн",
          Причина: this.validateIncome(income.source),
          Опис: income.log,
          Спосіб: income.payment_type === 1 ? "Готівка" : "Карта",
          Адмін: income.admin.name + " " + income.admin.surname,
          income: income,
        });
      });
      this.totalRows = options.length;
      return options;
    },
    async deleteIncome(income) {
      let confirmation = confirm(`Удалить ${income.log} за ${income.amount}?`);
      if (confirmation) {
        let config = {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        };
        await axios
          .delete(
            `${process.env.VUE_APP_API}/money/remove/income/?income_id=${income.id}`,
            config,
          )
          .then((response) => {
            console.log(response);
            this.$emit("refresh-balance");
          })
          .catch((err) => {
            if (err.response.status === 403) {
              console.log("x");
              this.showModalCreate("Недостатньо прав.", "red");
            } else if (err.response.status === 401) {
              this.logOutUser();
            }
          });
      }
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("HH:mm:SS");
    },
  },
};
</script>

<style scoped></style>
